var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-layout",
    [
      _c(
        "v-flex",
        [
          _c(
            "v-tabs",
            {
              model: {
                value: _vm.active,
                callback: function ($$v) {
                  _vm.active = $$v
                },
                expression: "active",
              },
            },
            [
              _c("v-tab", [_c("h6", [_vm._v("Server logs (Elk)")])]),
              _vm._v(" "),
              _c("v-tab", [_c("h6", [_vm._v("Logs from collector box")])]),
              _vm._v(" "),
              _c("v-tab", [_c("h6", [_vm._v("Log files from collector box")])]),
              _vm._v(" "),
              _c("v-tab-item", [_c("elklogs-subpanel")], 1),
              _vm._v(" "),
              _c("v-tab-item", [_c("logs-subpanel")], 1),
              _vm._v(" "),
              _c(
                "v-tab-item",
                [
                  _c(
                    "v-card",
                    { attrs: { flat: "" } },
                    [
                      _c(
                        "v-card-title",
                        [
                          _c(
                            "h3",
                            { staticClass: "headline mb-0 admin-header" },
                            [_vm._v("Log Files")]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                text: "",
                                icon: "",
                                color: "grey lighten-1",
                                loading: _vm.loadingCollectors || _vm.loading,
                              },
                              on: { click: _vm.refreshLogFiles },
                            },
                            [_c("v-icon", [_vm._v("fas fa-sync")])],
                            1
                          ),
                          _vm._v(" "),
                          _c("v-select", {
                            attrs: {
                              items: _vm.allCollectors,
                              "item-text": "id",
                              "item-value": "id",
                              label: "Source Collector",
                            },
                            model: {
                              value: _vm.selectedCollectorId,
                              callback: function ($$v) {
                                _vm.selectedCollectorId = $$v
                              },
                              expression: "selectedCollectorId",
                            },
                          }),
                          _vm._v(" "),
                          _c("v-spacer"),
                          _vm._v(" "),
                          _c("v-text-field", {
                            attrs: {
                              "append-icon": "fal fa-search",
                              placeholder: "Search",
                              "single-line": "",
                              "hide-details": "",
                              clearable: "",
                            },
                            model: {
                              value: _vm.searchLogFiles,
                              callback: function ($$v) {
                                _vm.searchLogFiles = $$v
                              },
                              expression: "searchLogFiles",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-data-table", {
                        staticClass: "elevation-1",
                        attrs: {
                          items: _vm.filteredLogFiles(),
                          search: _vm.searchLogFiles,
                          loading: _vm.loading,
                          headers: _vm.fileheaders,
                          options: _vm.paginationFL,
                        },
                        on: {
                          "update:options": function ($event) {
                            _vm.paginationFL = $event
                          },
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "item.name",
                            fn: function ({ item }) {
                              return [
                                _c(
                                  "td",
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: { text: "", color: "blue" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.downloadFile(
                                              item.collector,
                                              item.name
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(item.name))]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                          {
                            key: "item.lastModified",
                            fn: function ({ item }) {
                              return [
                                _c("td", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.formatDateTime(item.lastModified)
                                    )
                                  ),
                                ]),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }